import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/loading.gif'


const _hoisted_1 = {
  class: "loading",
  id: "loading"
}
const _hoisted_2 = { class: "load_box" }

import { Ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    show: {},
    message: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.message.value), 1)
    ])
  ], 512)), [
    [_vShow, _ctx.show.value]
  ])
}
}

})